import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../common/Sidebar';
import { AdminGetAllCustomer } from "../../Api/Admin/authServices";

const CustomerList = () => {
    const [customers, setCustomers] = useState([]); // Default to an empty array
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchCustomers = async () => {
            const token =localStorage.getItem("token");
            setLoading(true);
            try {
                const res = await AdminGetAllCustomer(token);
                console.log(res.data);
                setCustomers(res.data);
            } catch (error) {
                console.error('Error fetching customers:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchCustomers();
    }, []);

    const handleCustomerClick = (id) => {
        navigate(`/customers/${id}`);
    };

    return (
        <div className="flex min-h-screen">
            <Sidebar />
            <div className="flex-1 p-6 bg-gray-50" style={{ marginLeft: '16rem' }}>
                <div className="text-2xl font-semibold mb-4">Customer List</div>
                <div className="p-4 bg-white shadow rounded">
                    {loading ? (
                        <div className="text-center py-6 text-gray-500">Loading...</div>
                    ) : customers.length === 0 ? (
                        <div className="text-center py-6 text-gray-500">No customers found.</div>
                    ) : (
                        <table className="min-w-full border-collapse border border-gray-200">
                            <thead className="bg-gray-100">
                                <tr>
                                    <th className="px-4 py-2 border border-gray-200 text-left text-sm font-medium text-gray-700">Id</th>
                                    <th className="px-4 py-2 border border-gray-200 text-left text-sm font-medium text-gray-700">Name</th>
                                    <th className="px-4 py-2 border border-gray-200 text-left text-sm font-medium text-gray-700">Email</th>
                                    <th className="px-4 py-2 border border-gray-200 text-left text-sm font-medium text-gray-700">Contact Number</th>
                                </tr>
                            </thead>
                            <tbody>
                                {customers.map((customer) => (
                                    <tr
                                        key={customer._id}
                                        className="hover:bg-gray-50 cursor-pointer"
                                        onClick={() => handleCustomerClick(customer._id)}
                                    >
                                        <td className="px-4 py-2 border border-gray-200 text-sm text-gray-700">{customer._id}</td>
                                        <td className="px-4 py-2 border border-gray-200 text-sm text-gray-700">{customer.fullName}</td>
                                        <td className="px-4 py-2 border border-gray-200 text-sm text-gray-700">{customer.email}</td>
                                        <td className="px-4 py-2 border border-gray-200 text-sm text-gray-700">{customer.contactNumber}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CustomerList;
